module.exports = __webpack_public_path__ + "c6f03ccdcbcf0fc923b9d7685bf60d42.svg";